// router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// 静态路由（所有用户可见）
const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/login/LoginPage.vue')
  },
  {
    name: 'Home',
    path: '/Home',
    redirect: '/Home/Workbench', // 自动重定向到默认子路由
    component: () => import('@/views/home/Home.vue'),
    children: [
      {
        name: "工作台",
        path: '/Home/Workbench',
        component: () => import('@/views/workbench/Workbench.vue'),
      },
      {
        name: "坐席中心",
        path: '/Home/zuoxiZhongxin',
        component: () => import('@/views/zuoxiZhongxin/zuoxiZhongxin.vue'),
      },
      // {
      //   name: "AI坐席客服",
      //   path: '/Home/AiCustomerService',
      //   component: () => import('@/views/Agentcustomerservice/AiCustomerService.vue'),
      // },
      {
        name: "我的工单",
        path: '/Home/MyWorkOrder',
        component: () => import('@/views/WorkOrderCenter/MyWorkOrder.vue'),
      },
      // {
      //   name: "知识库",
      //   path: '/Home/KnowledgeBase',
      //   component: () => import('@/views/KnowledgeBase/KnowledgeBase.vue'),
      // },
      {
        name: "通话记录",
        path: '/Home/CallRecord',
        component: () => import('@/views/CallRecord/CallRecord.vue'),
      },
      {
        name: "我的客户",
        path: '/Home/MyCustomer',
        component: () => import('@/views/MyCustomer/MyCustomer.vue'),
      },
      {
        name: "通讯录",
        path: '/Home/AddressBook',
        component: () => import('@/views/AddressBook/AddressBook.vue'),
      },
      {
        name: "小助手小郸",
        path: '/Home/AssistantH5',
        component: () => import('@/views/AssistantH5/AssistantH5.vue'),
      }
    ]
  },
  // {
  //   name: "小助手H5",
  //   path: '/AssistantH5',
  //   component: () => import('@/views/AssistantH5/AssistantH5.vue'),
  // }
  //   {
  //     path: '/404',
  //     component: () => import('@/views/404.vue')
  //   }
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})


export default router